import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const CalendarIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="29" viewBox="0 0 31 29" className={className} onClick={onClick}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#000" fillRule="nonzero" transform="translate(-716 -739)">
          <g transform="translate(69 370)">
            <g transform="translate(647 369)">
              <path d="M29.52 2.41h-5.91V1.2a1.2 1.2 0 10-2.4 0v1.21H9.51V1.2a1.2 1.2 0 10-2.4 0v1.21H1.2A1.2 1.2 0 000 3.61v23.51a1.2 1.2 0 001.2 1.2h28.32a1.2 1.2 0 001.2-1.2V3.61a1.2 1.2 0 00-1.2-1.2zm-1.2 23.51H2.4V4.81h4.71v1.21a1.2 1.2 0 102.4 0V4.81h11.7v1.21a1.2 1.2 0 102.4 0V4.81h4.71v21.11z"></path>
              <circle cx="15.36" cy="12.897" r="1.62"></circle>
              <circle cx="15.36" cy="19.948" r="1.62"></circle>
              <circle cx="8.309" cy="12.897" r="1.62"></circle>
              <circle cx="22.411" cy="12.897" r="1.62"></circle>
              <circle cx="8.309" cy="19.948" r="1.62"></circle>
              <circle cx="22.411" cy="19.948" r="1.62"></circle>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CalendarIcon;
